<div class="report-modal-backdrop">
  <section class="report-modal" role="dialog" aria-modal="true" aria-labelledby="report-modal-title">
    <header>
      <h2 id="report-modal-title">Solicitar reporte</h2>
    </header>
    @if (contextLoading()) {
      <div class="report-modal__loading" role="status">
        <span class="report-modal__spinner" aria-hidden="true"></span>
        <span>Cargando datos del reporte…</span>
      </div>
    } @else if (contextUnavailable() || action().reportStatus !== 'AVAILABLE') {
      <p>La solicitud de reporte ya no está disponible.</p>
    } @else if (contextError()) {
      <p>No pudimos cargar los datos del reporte. Inténtalo de nuevo.</p>
      <button type="button" (click)="loadContext()">Reintentar</button>
    } @else {
      <label for="report-agent-code">Placa</label>
      <input id="report-agent-code" type="text" maxlength="120" [ngModel]="agentCode()"
        (ngModelChange)="agentCode.set($event)" [disabled]="submitting()" />
      <fieldset>
        <legend class="report-modal__visually-hidden">Tipo de solicitud de reporte</legend>
        <label><input type="radio" name="deliveryTarget" value="REQUESTER"
          [checked]="deliveryTarget() === 'REQUESTER'" [disabled]="submitting()"
          (change)="deliveryTarget.set('REQUESTER')" /> Generar reporte en este chat</label>
        <label><input type="radio" name="deliveryTarget" value="CASH_DESK"
          [checked]="deliveryTarget() === 'CASH_DESK'" [disabled]="submitting()"
          (change)="deliveryTarget.set('CASH_DESK')" /> Enviar reporte a caja</label>
      </fieldset>
      <button type="button" class="report-submit" [disabled]="!canSubmit()"
        (click)="submit()">{{ submitting() ? 'Solicitando…' : deliveryTarget() === 'REQUESTER' ? 'Generar reporte' : 'Enviar a caja' }}</button>
    }
    <button type="button" class="report-cancel" [disabled]="submitting()" (click)="close()">Cancelar</button>
  </section>
</div>
